<template>
  <div class="PmEventsPure" :style="styles">
    <slot />
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { differenceInCalendarDays } from 'date-fns'

export interface Props {
  containerStartDate: Date
  containerEndDate: Date
}

const props = defineProps<Props>()

const numberOfDays = computed(() => {
  return (
    differenceInCalendarDays(props.containerEndDate, props.containerStartDate) +
    1
  )
})

const styles = computed(() => {
  return {
    gridTemplateColumns: `repeat(${numberOfDays.value}, var(--dayWidth)`,
  }
})
</script>

<style lang="scss">
.PmEventsPure {
  $block: &;

  display: grid;
  grid-auto-flow: dense;
  align-items: start;
  width: min-content;
  padding-bottom: 4px;
}
</style>
